import { MultipleThresholds, SingleThreshold } from './moderationFiltersTypes';

import { createMultipleThresholds } from './createMultipleThresholdsUtil';

export const INCIVILITY_THRESHOLD_CONFIG = 'openweb_incivility_thresholds';
export const INCIVILITY_TAGGER_FEATURE_FLAG = 'openweb_incivility_tagger_enabled';
export const TEXT_ANALYZER_SETTINGS = 'text_analyzer_settings';
export const MODELS_CONFIG = 'models_config';
export const SUSPECTED_BOT_ENABLED = 'suspected_bot_tagger_enabled';
export const SUSPECTED_BOT_THRESHOLD = 'suspected_bot_tagger_threshold';

export const MODERATION_FILTERS_CONFIGS = [
  INCIVILITY_THRESHOLD_CONFIG,
  INCIVILITY_TAGGER_FEATURE_FLAG,
  TEXT_ANALYZER_SETTINGS,
  MODELS_CONFIG,
  SUSPECTED_BOT_ENABLED,
  SUSPECTED_BOT_THRESHOLD
] as const;

export const DEFAULT_SINGLE_THRESHOLD: SingleThreshold = {
  type: 'single',
  threshold: 95
};

export const HIGH_PERCENTAGE_THRESHOLD: MultipleThresholds = createMultipleThresholds(90, 95, 98);
export const MEDIUM_PERCENTAGE_THRESHOLD: MultipleThresholds = createMultipleThresholds(95, 97, 99);
export const LOW_PERCENTAGE_THRESHOLD: MultipleThresholds = createMultipleThresholds(100, 99, 100);

export const HIGH_NUM_THRESHOLD: MultipleThresholds = createMultipleThresholds(2, 3, 4);
export const MEDIUM_NUM_THRESHOLD: MultipleThresholds = createMultipleThresholds(4, 5, 6);
export const LOW_NUM_THRESHOLD: MultipleThresholds = createMultipleThresholds(5, 6, 7);

export const SPAM_SIMILARITY_DEFAULT_THRESHOLDS: MultipleThresholds = createMultipleThresholds(100, 100, 96);

export const MODERATION_NS = 'tenant.moderation';

export const OW_MODEL_PREFIX = 'ow_';

export const INAPPROPRIATE_USERNAME_MODEL = 'ow_username';
